import { useEffect, useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Message, Session } from 'talkjs/all';
import type { RcsConversation, RcsState } from './rcs.types';
import { setRcsUnseenMessageStatus } from './rcsSlice';

const useHandleUnreadRCS = (session: Session | null) => {
  const dispatch = useDispatch();
  const rcsConversations = useSelector(
    (state: { rcs: RcsState }) => state.rcs.conversations,
  );
  const conversationListenerSetup = useRef(false);
  const rcsConversationsRef =
    useRef<Record<string, RcsConversation>>(rcsConversations);

  // Update a reference to conversations so the session useEffect is up to date
  useEffect(() => {
    rcsConversationsRef.current = rcsConversations;
  }, [rcsConversations]);

  // onMessage() functions stack not replace. Thus, need to ensure only gets called ONCE
  useEffect(() => {
    if (!session?.onMessage || conversationListenerSetup.current) {
      return;
    }

    conversationListenerSetup.current = true;

    session.onMessage((message: Message) => {
      const conversationID: string = message.conversation.id;
      const queue = rcsConversationsRef.current;

      const matchingCall = Object.keys(rcsConversationsRef.current).find(
        callerID => {
          return queue[callerID].data?.conversation_id === conversationID;
        },
      );

      if (matchingCall) {
        dispatch(
          setRcsUnseenMessageStatus({
            callerID: matchingCall,
            messageID: message.id,
            unseenMessage: true,
          }),
        );
      }
    });

    return () => {
      conversationListenerSetup.current = false;
    };
  }, [dispatch, session]);
};

export default useHandleUnreadRCS;
